import {ChangeDetectorRef, Component, ElementRef, forwardRef, NgZone, Renderer2} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractImageInput} from "../abstract-image-input";
import {CanvasType} from "../../image.component";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditImageInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-image-input",
    styleUrls: ["./edit-image-input.component.scss"],
    templateUrl: "./edit-image-input.component.html",
    standalone: false
})
export class FUIEditImageInputComponent extends FUIAbstractImageInput {
    CanvasType = CanvasType;

    canvasType: CanvasType = CanvasType.CHECKERED;

    constructor(changeDetectorRef: ChangeDetectorRef,
                element: ElementRef,
                ngZone: NgZone,
                renderer: Renderer2) {
        super(changeDetectorRef, element, ngZone, renderer);
    }

    public cycleCanvas(): void {
        this.canvasType = (this.canvasType + 1) % 3;
    }
}
